export default __webpack_public_path__ + "static/media/VO_CLOSE.292699fd.svg";